import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import "react-times/css/classic/default.css";
import { toast } from "react-toastify";
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import Config from "services/config/config";
import axios from "services/interceptor/Interceptor";
import './plan.css';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';

const PlanSchedule = ({
  match,
  history,
  getCorpClientList,
  corpClientList,
  getClientEmail,
  clientEmail,
  getMeetingById,
  createAndSendMom,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [attachmentUrl, setAttachmentUrl] = useState("");
  const [disabledElement, setDisabledElement] = useState(false);

  const handleSubmit = async () => {
    if(attachmentUrl == "" || attachmentUrl == null) {
        toast.error('Please upload csv file.');
        return false;
    }
    const payload = {
        'file': attachmentUrl
    }
    setIsLoading(true);
    setDisabledElement(true);
    const url = `${Config.brandActivation.uploadMeetingPlan}`;
    const { data } = await axios.post(url,payload);
    if(data) {
        setIsLoading(false);
        toast.success('File uploaded successfully');
        setTimeout(function() {
          window.location.reload();
      }, 4000);
    } else {
        setIsLoading(false); 
        toast.error('File data not processed, some error occured.');
        // setTimeout(() => history.push(`${baseUrl}/brand-activation/file-meeting-upload-list`), 1000);
        setDisabledElement(false);
    }
    setIsLoading(false); 
  }

  const headerBtn = () => {
    return (
        <>
          <a className="btn btn-primary" href="https://ik.imagekit.io/parkplus/production/carnival/public/1705037877_20240112110713912454.csv" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="hide-on-desktop bi bi-download" viewBox="0 0 16 16">
                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
            </svg>
            <span className="hide-on-app">Download Sample File</span>
          </a>  
        </>
    )
  }
  

  return (
    <Layout
      title={localization.planSchedule}
      isGoback
      isLoading={isLoading}
      Buttons={headerBtn}
    >
      <div className="container-fluid">
        <div className="card">
          <div className="panel-heading">Plan Schedule</div>
          <div className="card-body">
            <div className="row">
             <div className="col-md-12 col-sm-12">
                <FileUpload
                  id={"addAttachment"}
                  accept=".csv"
                  documentUploadUrl={documentUploadUrlPublic}
                  documentUrlData={documentUrlDataPublic}
                  onChange={(val) => setAttachmentUrl(val)}
                  //multiple={true}
                >
                  <span className="btn btn-transparent">
                    {localization.uploadCSV}
                  </span>
                </FileUpload>
              </div> 
            </div>
            <div
              style={{ "marginTop": "20px" }}
              className="col-md-12 col-sm-5"
            >
              <button disabled={disabledElement} className="btn btn-sm btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default PlanSchedule;
